export default __webpack_public_path__ + "static/media/protractor.fc0708f3.svg";